import React from 'react';
import PropTypes from 'prop-types';
import DateFields from './DateFields';
import OutcomeField from './OutcomeField';
import NoteField from './NoteField';
import SkeletonFields from './SkeletonFields';

const CaseCloseFields = ({
  minDate,
  minOpenedDate,
  outcomeLabel,
  outcomes,
  showFields,
  showSkeleton,
  showExitedAtField,
  showOpenAndClosedDateInputs,
  useStagedOutcomeFlow,
  values,
}) => {
  if (useStagedOutcomeFlow && showSkeleton) {
    return (
      <SkeletonFields
        outcomes={outcomes}
        resolvedValue={values.resolved}
      />
    );
  }

  if (useStagedOutcomeFlow && !showFields) {
    return null;
  }

  return (
    <>
      <OutcomeField
        outcomeLabel={outcomeLabel}
        outcomes={outcomes}
        resolvedValue={values.resolved}
        useRadioOutcomes={useStagedOutcomeFlow}
      />
      <NoteField />
      <DateFields
        minDate={minDate}
        minOpenedDate={minOpenedDate}
        showExitedAtField={showExitedAtField}
        showOpenAndClosedDateInputs={showOpenAndClosedDateInputs}
        values={values}
      />
    </>
  );
};

CaseCloseFields.propTypes = {
  minDate: PropTypes.string,
  minOpenedDate: PropTypes.string,
  outcomeLabel: PropTypes.string.isRequired,
  outcomes: PropTypes.array.isRequired,
  showFields: PropTypes.bool.isRequired,
  showSkeleton: PropTypes.bool.isRequired,
  showExitedAtField: PropTypes.bool.isRequired,
  showOpenAndClosedDateInputs: PropTypes.bool.isRequired,
  useStagedOutcomeFlow: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
};

CaseCloseFields.defaultProps = {
  minDate: null,
  minOpenedDate: null,
};

export default CaseCloseFields;
